import { CSSProperties } from "@material-ui/core/styles/withStyles";
import { colors } from "@clockwise/web-commons/src/styles/color.styles";

const container: CSSProperties = {
  marginTop: 15,
};

export const selectStyle = {
  style: {
    width: "100%",
    height: 62, // default height - 10px
  } as CSSProperties,
  menuStyle: {
    marginTop: 4, // default marginTop - 10px
  } as CSSProperties,
  labelStyle: {
    paddingRight: 30,
    fontSize: 14,
  } as CSSProperties,
  floatingLabelStyle: {
    top: 28, // default top - 10px
  } as CSSProperties,
  iconStyle: {
    width: 30,
    padding: 0,
  } as CSSProperties,
  selectedMenuItemStyle: {
    color: colors.green.standard,
  } as CSSProperties,
};

const menuItem: CSSProperties = {
  paddingLeft: 10,
};

export const styles = {
  container,
  menuItem,
};
